import { TweenMax } from 'gsap';
import { HoverIntent } from 'jquery-hoverintent';

class Navigation {

	constructor() {
	}

	static init() {
		NavComponent.attachEvents();
	}

	attachEvents() {

		if ($('html').hasClass('no-touchevents')) {

			$('.header-navigation .has-children').hoverIntent(function(){
				var $this = $(this),
					$subMenu = $this.find('.header-navigation-sub').length > 0 ? $this.find('.header-navigation-sub') : $this.find('.header-navigation-sub-sub');

				if ($('.header-navigation-sub').is(':visible')) {
					NavComponent.openSubMenuDesktop($subMenu, 0.2);
				} else {
					NavComponent.openSubMenuDesktop($subMenu, 0);
				}

			}, function(){
				var $this = $(this),
					$subMenu = $this.find('.header-navigation-sub').length > 0 ? $this.find('.header-navigation-sub') : $this.find('.header-navigation-sub-sub');

				NavComponent.closeSubMenuDesktop($subMenu, 0.4);
			}, $.noop);
		}

		$(document).on('click', '.js-toggle-nav-sub', function(e) {
			e.preventDefault();
			var $this = $(this),
				$subMenu = $this.next('.mobile-navigation-sub');

			NavComponent.openSubMenuMobile($subMenu);
		});

		$(document).on('click', '.js-close-nav-sub', function(e) {
			e.preventDefault();
			NavComponent.closeSubMenuMobile($(this).parent('.mobile-navigation-sub'));
		});
	}

	openSubMenuDesktop($subMenu, delay) {
		$('body').addClass('submenu-opened');

		var $subMenuHeight = $subMenu.height() + 47;
		TweenMax.to('.header-navigation-list', 0.3, {
			height: $subMenuHeight
		});

		TweenMax.to($subMenu, 0.4, {
			display: 'block',
			opacity: 1,
			delay: 0.1
		});
	}

	closeSubMenuDesktop($subMenu, delay) {
		$('body').removeClass('submenu-opened');

		var $navList = $('.header-navigation-list');

		if (!$('body').hasClass('submenu-opened')) {
			TweenMax.to($navList, 0.5, {
				height: '50px',
				delay: 0.1
			});
		}

		TweenMax.to($subMenu, 0.2, {
			display: 'none',
			opacity: 0,
			delay: 0.1
		});
	}

	openSubMenuMobile($subMenu) {
		TweenMax.to($subMenu, 0.4, {
			display: 'block',
			x: '0%'
		});

		$subMenu.addClass('is-active');
	}

	closeSubMenuMobile($subMenu) {
		TweenMax.to($subMenu, 0.4, {
			display: 'none',
			x: '100%'
		});

		$subMenu.removeClass('is-active');
	}
}

export default Navigation;

const NavComponent = new Navigation;
